export const MENU_ITEM_SHARE_APP_MESSAGE = 'menuItem:share:appMessage';
export const MENU_ITEM_SHARE_TIMELINE = 'menuItem:share:timeline';



// WEBPACK FOOTER //
// ./src/constants/jssdk.js